import React, {createContext, useContext, useCallback, useEffect, useRef} from 'react';
import {ApiClientService, useAuth} from '@dofleini/security';
import {authentication} from '@/settings';
import checkAuthClientInfo from '@/utils/checkAuthClientInfo';
import {useQueryClient} from 'react-query';

const SessionControlContext = createContext();

export const REFRESH_TOKEN_KEY = '__refresh_token__';
export const SPACE_KEY = '__space__';

export const setAuthData = (data = {}) => {
  const {accessToken, refreshToken, space} = data;
  window.localStorage.setItem(ApiClientService.ACCESS_TOKKEN_KEY, accessToken);
  window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  window.localStorage.setItem(SPACE_KEY, space);
  checkAuthClientInfo();
};

export const handleUserResponse = ({data}) => {
  setAuthData(data);
  return data;
};

export const refreshToken = () => {
  const token = window.localStorage.getItem(ApiClientService.ACCESS_TOKKEN_KEY);
  const refresh = window.localStorage.getItem(REFRESH_TOKEN_KEY);
  const space = window.localStorage.getItem(SPACE_KEY);
  window.localStorage.clear();
  ApiClientService.removeDefaultHeader('x-workspace');

  return ApiClientService.post(`${authentication.path}/api/refresh-token`, {
    token,
    refresh,
    space
  }).then(handleUserResponse);
};

const SessionControlProvider = (props) => {
  const flagStatus = useRef({});
  const {logout} = useAuth();
  const queryClient = useQueryClient();

  const refresh = useCallback(async (e) => {
    if (!flagStatus?.current?.isRefreshing && e?.response?.data?.message === 'jwt expired') {
      try {
        flagStatus.current.isRefreshing = true;
        await refreshToken();
        queryClient.invalidateQueries();
      } catch (e) {
        logout();
      }
      flagStatus.current.isRefreshing = false;
    }
  }, [logout, queryClient]);

  useEffect(() => {
    ApiClientService.onError(refresh, 401);
  }, [refresh]);

  return (
    <SessionControlContext.Provider value={{refresh}} {...props}/>
  );
};

const useSessionControl = () => {
  const context = useContext(SessionControlContext);
  if (context === undefined) {
    throw new Error('useSessionControl must be used within a SessionControlProvider');
  }
  const {refresh} = context;
  return {refresh};
};

SessionControlProvider.propTypes = {};


export {SessionControlProvider, useSessionControl};
